import { useQuery, useQueryClient } from "@tanstack/react-query";
import { BellRing } from "lucide-react";
import { toast } from "sonner";
import { PushDeviceRow } from "@/components/settings/PushDeviceRow";
import { Switch } from "@/components/ui/switch";
import { api, formatApiError } from "@/lib/api";

const ROWS = [
  ["email", "Recevoir les notifications par email", "Interrupteur général pour tous les emails CASHMY."],
  ["digest", "Résumé quotidien des alertes", "Chaque matin à 8 h dans la cloche (et par email si activé) : garanties, entretiens, consommation, budgets."],
  ["repair", "Réparations (SAV)", "Devis reçu, intervention démarrée ou terminée, messages."],
  ["claim", "Sinistres", "Réponse de l'assureur, indemnisation, messages."],
];

export const NotificationsCard = () => {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["notif-prefs"], queryFn: () => api.get("/notifications/preferences").then((r) => r.data) });
  const toggle = async (k, v) => {
    try {
      const { data: d } = await api.put("/notifications/preferences", { [k]: v });
      qc.setQueryData(["notif-prefs"], d);
      toast.success("Préférences enregistrées");
    } catch (e) { toast.error(formatApiError(e)); }
  };
  if (!data) return null;
  return (
    <section className="card-surface space-y-4 p-6" data-testid="notifications-card">
      <div className="flex items-center gap-3">
        <span className="tone-chip tone-butter flex h-9 w-9 items-center justify-center rounded-xl"><BellRing className="h-4 w-4" /></span>
        <h2 className="text-lg font-bold">Notifications</h2>
      </div>
      {!data.email_available && <p className="rounded-xl bg-secondary p-3 text-xs text-muted-foreground" data-testid="notifications-demo-note">Compte de démonstration : les notifications s'affichent dans la cloche, aucun email n'est envoyé.</p>}
      <ul className="divide-y divide-border">
        <PushDeviceRow />
        {ROWS.map(([k, label, hint]) => (
          <li key={k} className="flex items-center gap-4 py-3">
            <div className="min-w-0 flex-1"><div className="text-sm font-medium">{label}</div><div className="text-xs text-muted-foreground">{hint}</div></div>
            <Switch checked={!!data[k]} disabled={!["email", "digest"].includes(k) && !data.email} onCheckedChange={(v) => toggle(k, v)} data-testid={`notif-pref-${k}`} />
          </li>
        ))}
      </ul>
      <p className="text-xs text-muted-foreground">Les notifications restent toujours visibles dans la cloche, même sans email.</p>
    </section>
  );
};
